module.exports = __webpack_public_path__ + "static/img/file_php.bcee3b07.png";